import { NativeStackScreenProps } from '@react-navigation/native-stack';

export interface FixedLimitModalProps {
  onLayout: (event: any) => void;
}

export enum FixedLimitStackRoutes {
  Main = 'main',
  Confirm = 'confirm',
  Placed = 'placed'
}

export type FixedLimitStackParamList = {
  [FixedLimitStackRoutes.Main]: FixedLimitModalProps & {
    record?: any;
    onData: (data: any) => void;
    func?: (limit: number, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
  };
  [FixedLimitStackRoutes.Confirm]: FixedLimitModalProps & {
    record?: any;
    data: any;
    func?: (limit: number, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
  };
  [FixedLimitStackRoutes.Placed]: FixedLimitModalProps & {
    record?: any;
    data?: any;
    returnData?: any;
    refresh?: () => void;
  };
};

export type FixedLimitStackScreenProps<Screen extends keyof FixedLimitStackParamList> = NativeStackScreenProps<
  FixedLimitStackParamList,
  Screen
>;
